import Sidebar from '../../components/Sidebar';
import AuthHeader from '../../components/Header/AuthHeader';
import { Grid, LinearProgress } from '@material-ui/core';
import ButtonCommon from "../../components/ButtonCommon";
import TradeUp from '../../assets/TradeUp';
import LockBlue from '../../assets/LockBlue';
import DisbursalIcon from '../../assets/DisbursalIcon';
import ProcessingIcon from '../../assets/ProcessingIcon';
import './index.scss';
import { useState, useEffect, Fragment } from 'react';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import TimerIcon from '@material-ui/icons/Timer';
import PayModalChalan from './PlayChalanModal';
import PayEarlierModal from './PayEarlierModal';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getCreditLineDetail } from '../../api/challan';
import moment from 'moment-timezone';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useSelector } from 'react-redux';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

function formatDollar(num) {
	if (num === 0) {
		return '0'
	}
	if (!num) {return}
		num = parseFloat(num);
    var p = num.toFixed(1).split(".");
    var chars = p[0].split("").reverse();
    var newstr = '';
    var count = 0;
    for (let x in chars) {
        count++;
        if(count%3 == 1 && count != 1) {
            newstr = chars[x] + ',' + newstr;
        } else {
            newstr = chars[x] + newstr;
        }
    }
    return newstr
    //return newstr + "." + p[1];
}

const Dashboard = (props) => {
	const [ modal , setModal ] = useState(false);
	const [loading, setLoading] = useState(true);
	const [details, setDetails] = useState({});
	const [earlyModal, setEarlyModal] = useState(false);
	const { sidebar } = useSelector((state) => state.user)

	useEffect(() => {
		const urlParams = new URLSearchParams(props?.history?.location?.search);
		if (urlParams.has('status') && (urlParams.get('status') === "SUCCESS" || urlParams.get('status') === "success")) {
			urlParams.delete('status')
			props.history.push({replace: true, search: urlParams.toString()});
			setTimeout(() => {
				fetchCreditDetail();
			}, 4000);
		} else {
			fetchCreditDetail();
		}
	}, []);

	const fetchCreditDetail = () => {
		setLoading(true);
		getCreditLineDetail().then(res => {
			setLoading(false);
			setDetails(res)
		})
	}

	const renderTransactionIcon = (type) => {
		if (type === 'DISBURSED') {
			return <DisbursalIcon />	
		} else if (type === 'PROCESSING') {
			return <ProcessingIcon />
		} else {
			return <LockBlue />	
		}
	}

	const renderTransactionIconAcc = (status) => {
		if (status === 'DISBURSED') {
			return <p className="transStatus">
				<CheckCircleOutlineIcon />
				{status}
			</p>
		} else if (status === 'PROCESSING' || status === 'CONFIRMED') {
			return <p className="transStatus warn">
				<TimerIcon />
				PROCESSING
			</p>
		} else if (status === 'PAID') {
			return <p className="transStatus">
				<CheckCircleOutlineIcon />
				{status}
			</p>
		} else if (status === 'CANCELLED') {
			return <p className="transStatus gray">
				<CloseIcon />
				{status}
			</p>
		} else if (status === 'OVERDUE') {
			return <p className="transStatus error">
				<WarningIcon />
				{status}
			</p>
		}
	}

	const renderTransactionsAcc = () => {
		if (details.transactions?.length) {
			return details.transactions.map((item, index) => {
				return <Accordion>
	        <AccordionSummary
	          expandIcon={<ExpandMoreIcon />}
	          key={index}
	        >
	          	<div className="dueItem">
					<div className="dueContent">
						<h4>
							₹ {formatDollar(parseFloat(item.disbursalAmount))}
							{renderTransactionIconAcc(item.status)}
							
						</h4>
						<p>For GST Challan added on {moment.utc(item.createdAt).tz("Asia/Kolkata").format('DD MMM')}</p>
					</div>
					<div className="dueAction">
						{/*<p>{item.transactionStatus}</p>*/}
					</div>
				</div>
	        </AccordionSummary>
	        <AccordionDetails>
	        	<Grid container spacing={3}>
	        		<Grid item md={12}>
	        			<h6>View break up</h6>
	        			<ul className="detailInfo">
			        		{item.disbursalAmount && 
							<li>
			        			<label>Amount paid to GST ledger</label>
			        			₹ {formatDollar(item.disbursalAmount)}
			        		</li>}
			        		{item.processingFee.length &&
							<li>
								<label>
									One time processing fee
									<span className="helpIcon feeIcon">
									<HelpOutlineIcon />
									<div className="toolTipBox">
										<p>Please note that, processing fee will be included as part of your first challan payment only. It will not be charged for any subsequent challan payments during the year. This fee facilitates legal, documentation and verification charges for our lending partner.</p>
									</div>
									</span>
								</label>
								₹ {formatDollar(item.processingFee)}
							</li>
							}
			        	</ul>
	        		</Grid>
	        		<Grid item md={12}>
	        			<h6>Transaction details</h6>
	        			<ul className="detailInfo">
			        		{item.emis?.length ? <li>
			        			<label>Repayment tenure</label>
			        			{item.emis.length ? `₹ ${item.emis.length} month EMI` : 'Processing...'} 
			        		</li> : ''}
			        		{item.emis?.length ? <li>
			        			<label>EMI per month</label>
			        			{item.emis?.length ? `₹ ${formatDollar(item.emis[0].amount)}` : 'Processing...'}
			        		</li> : ''}
			        		{item.interestRate ? <li>
			        			<label>Interest rate </label>
			        			{item.interestRate}% per day
			        		</li> : ''}
			        	</ul>
	        		</Grid>
					{item.paidAmount ? <Grid item md={12}>
	        			<h6>Repayment history</h6>
	        			<ul className="detailInfo">
			        		<li>
			        			<label>Total Repaid Amount</label>
			        			₹ {formatDollar(item.paidAmount)}
			        		</li>
			        	</ul>
	        		</Grid> : ''}
	        	</Grid>
	        </AccordionDetails>
	      </Accordion>
			})
		} else {
			return <div className="noDataAvail">No Transaction Available</div>
		}
	}

	const renderDues = () => {
		if (details.transactions?.length) {
			let filterDues = [];

			details.transactions.forEach(item => {
				if (item.emis?.length) {
					let filterEmis = item.emis.filter(emi => emi.status === 'PENDING' || emi.status === 'PARTIALLY_PAID');
					filterEmis = filterEmis.map(emi => {return {...emi, transactionDate: item.createdAt}})

					filterDues = [...filterDues, ...filterEmis]
				}
			})

			filterDues = filterDues.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate))
			if (!filterDues.length) {
				return <p>No dues</p>
			} else {
				return <Fragment> 
					{filterDues.map((item, i) => {
						return <Accordion>
			        <AccordionSummary
			          expandIcon={<ExpandMoreIcon />}
			          key={i}
			        >
			          	<div className="dueItem">
							<div className="dueContent">
								<h4>₹ {formatDollar(parseFloat(item.totalPayable))}</h4>
								<p>For GST Challan added on {moment.utc(item.transactionDate).tz("Asia/Kolkata").format('DD MMM')}</p>
							</div>
							<div className="dueAction">
								<p>Due on {moment.utc(item.dueDate).tz("Asia/Kolkata").format('DD MMM yyyy')}</p>
							</div>
						</div>
			        </AccordionSummary>
			        <AccordionDetails>
			        	<ul className="detailInfo">
							{item.amount ? <li>
			        			<label>EMI Amount </label>
			        			₹ {formatDollar(item.amount)}
			        		</li> : ''}
							{item.paidAmount ? <li>
			        			<label>Repaid amount </label>
			        			₹ {formatDollar(item.paidAmount)}
			        		</li> : ''}
			        		{returnCorsValue(item.charges, 'PROCESSING_FEE_CHARGE')
							?
							<li>
			        			<label>
									One Time Processing Fee 
									<span className="helpIcon feeIcon">
										<HelpOutlineIcon />
										<div className="toolTipBox">
											<p>Please note that, processing fee will be included as part of your first challan payment only. It will not be charged for any subsequent challan payments during the year. This fee facilitates legal, documentation and verification charges for our lending partner.</p>
										</div>
									</span>
								</label>
			        			₹ {formatDollar(returnCorsValue(item.charges, 'PROCESSING_FEE_CHARGE'))}
			        		</li> 
							: ''} 
			        		{returnCorsValue(item.charges, 'LATE_CHARGE') ? <li>
			        			<label>Late Charge </label>
			        			₹ {formatDollar(returnCorsValue(item.charges, 'LATE_CHARGE'))}
			        		</li> : ''}
			        		{returnCorsValue(item.charges, 'ENACH_BOUNCE_CHARGE') ? <li>
			        			<label>NACH Bounce charges </label>
			        			₹ {formatDollar(returnCorsValue(item.charges, 'ENACH_BOUNCE_CHARGE'))}
			        		</li> : ''}
			        		{item.totalPayable ? <li className="total">
			        			<label>Total amount due </label>
			        			₹ {formatDollar(item.totalPayable)}
			        		</li> : ''}
			        	</ul>
			        </AccordionDetails>
			      </Accordion>
					})}
				</Fragment>
			}
		} else {
			return <div className="noDataAvail">No Dues</div>
		}
	}

	const returnCorsValue = (data, key) => {
		if (data?.length) {
			let currentItem = data.find(item => item.chargeType === key);
			if (currentItem) {
				return currentItem['chargeAmount']
			}	
		}
	}

	const renderTransactionList = () => {
		if (details.transactions?.length) {
			return <Fragment>
				{details.transactions?.map((item, i) => {
					return <Grid key={i} container className="cardContent">
					{renderTransactionIcon(item.transactionStatus)}
						<p>
							{formatDollar(item.disbursalAmount)} {(item.transactionStatus).toLowerCase()}
						</p>
						<span>
							{moment.utc(item.createdAt).tz("Asia/Kolkata").format('DD MMM yy')}
						</span>
					</Grid>
				})}
			</Fragment>
		}
	}

	const renderPageContent = () => {
		if (loading && !details.status) {
			return <div className="loading">
        <CircularProgress />
      </div>
		} else {
			return <div className={`dashboardCon ${(details.status === 'INACTIVE' || details.status === 'UNDER_REVIEW') && 'inactive'}`}>
				{loading && 
					<div className="internalLoading">
						<div className="loading">
			        <CircularProgress />
			      </div>
					</div>
				}
				<Grid container spacing={3}>
					<Grid item md={12} sm={12} xs={12}>
						<div className="dashbordBox" style={{marginTop: 20}}>
							<div className="dashboardHeader">
								Your credit
								{details.validity && <span>Valid till {moment.utc(details.validity).tz("Asia/Kolkata").format('DD MMM yyyy')} </span>}
							</div>

							{details.status === 'INACTIVE' &&
								<div className="inactiveState">
									Your credit line has been temporarily suspended!
								</div>
							}
							{details.status === 'UNDER_REVIEW' &&
								<div className="inactiveState">
									Your request for a credit line is processing. It may take a maximum upto 24 hours.
								</div>
							}
							<Grid container spacing={3}>
								<Grid item md={8} sm={8} className="full-width">
									<div className="overviewBalance">
										<h3 className="limit"><sub>₹</sub>{formatDollar(details.availableLimit)}</h3>
										<h4>Available balance</h4>
									</div>
								</Grid>
								<Grid item md={4} sm={4} className="full-width">
									<ButtonCommon 
										className="payChallanButton" 
										disabled={details.status === 'INACTIVE' || details.status === 'UNDER_REVIEW'} 
										onClick={() => details.status === 'ACTIVE' && setModal(true)} 
										title={<p className="m-0"><AddCircleRoundedIcon style={{ fontSize: 20, marginTop: -3 }} /> Pay Challan</p>} 
									/>
								</Grid>
							</Grid>
							<div className="overviewSlider">
								<LinearProgress 
									variant="determinate" 
									value={(details.availableLimit / details.creditLimit) * 100} 
								/>
							</div>
							<Grid container spacing={3} className="sliderRange">
								<Grid item md={6} sm={6} xs={6}>
									<div className="overviewBalance">
										<h3><sub>₹</sub>{formatDollar(details.creditLimit - details.availableLimit)}</h3>
										<h4>Utilised</h4>
									</div>
								</Grid>
								<Grid item md={6} sm={6} xs={6} className="text-right">
									<div className="overviewBalance">
										<h3><sub>₹</sub>{formatDollar(details.creditLimit)}</h3>
										<h4>Total Limit</h4>
									</div>
								</Grid>
							</Grid>
						</div>
					</Grid>

					<Grid item md={6} sm={12} xs={12}>
						<div className="dashbordBox">
							<div className="dashboardHeader">
								All transaction history
							</div>
							<div className="duesCon transactionCon">
								{renderTransactionsAcc()}
							</div>
						</div>
					</Grid>
					<Grid item md={6} sm={12} xs={12}>
						<div className="dashbordBox">
							<div className="dashboardHeader">
								Upcoming Dues
								<button disabled={details.status === 'INACTIVE' || details.status === 'UNDER_REVIEW'} onClick={() => details.status === 'ACTIVE' && setEarlyModal(true)}>Make Payment <ArrowForwardIcon style={{width: 15}} /></button>
							</div>
							<div className="duesCon">
								{renderDues()}
							</div>
						</div>
					</Grid>
					{/*<Grid item md={4}>
						<div className="cardRight">
							<Grid container className="cardHeading">
								<TradeUp />
								<p>
									Your transactions
								</p>
							</Grid>
						
							{renderTransactionList()}

							<Grid container className="cardContent">
								<LockBlue />
								<p>
									Credit line unlocked
								</p>
								<span>
									{moment(details.createdAt).format('DD MMM yy')}
								</span>
							</Grid>

							<Grid container className="cardFooter">
								<p>
									View detailed transactions
								</p>
							</Grid>
						</div>
					</Grid>*/}
				</Grid>
			</div>
		}
	}

	return (
		<div className={`layout ${sidebar && 'menu_closed'}`}>
			<div className="layout_sidebar">
				<Sidebar {...props} />
			</div>
			<div className="layout_content">
				<AuthHeader />
				{renderPageContent()}
			</div>
			<PayModalChalan open={modal} closeModal={() => setModal(false)} refetchData={() => fetchCreditDetail()} />
			<PayEarlierModal open={earlyModal} closeModal={() => setEarlyModal(false)} refetchData={() => fetchCreditDetail()} />
		</div>
	)
}

export default Dashboard;
